import React, { type ReactElement } from 'react';

const NeutralIcon = (): ReactElement => (
  <svg width="16px" height="15px" viewBox="0 0 16 15">
    <title>Role requirements neutral Icon</title>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
      transform="translate(-453 -1097) translate(380 840) translate(70 145) translate(3.02 112)"
    >
      <ellipse cx="7.045" cy="7" fill="#A8A8A8" rx="7.045" ry="7" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
        d="M4.026 7h6.038"
      />
    </g>
  </svg>
);

export default NeutralIcon;
